import React from "react";
import Capacities from "./Capacities";
import Categories from "./Categories";
import RefreshDate from "./RefreshDate";
import YearSwitcher from "./YearSwitcher";
import { useViewportMode } from "@utils/useMobileDetection";

const LeftPanel = () => {
  const { isTablet } = useViewportMode();
  const gapClass = isTablet ? "gap-[12px]" : "gap-[16px]";

  return (
    <div className={`flex flex-col ${gapClass}`}>
      <RefreshDate />
      <Categories />
      <YearSwitcher />
      <Capacities />
    </div>
  );
};

export default LeftPanel;
